/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum StaticFlag {
    ZERO = 'zero',
    ONE = 'one',
    TWO = 'two',
    THREE = 'three',
    FOUR = 'four',
    FIVE = 'five',
    SIX = 'six',
    SEVEN = 'seven'
}


export function instanceOfStaticFlag(value: any): boolean {
    for (const key in StaticFlag) {
        if (Object.prototype.hasOwnProperty.call(StaticFlag, key)) {
            if (StaticFlag[key as keyof typeof StaticFlag] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StaticFlagFromJSON(json: any): StaticFlag {
    return StaticFlagFromJSONTyped(json, false);
}

export function StaticFlagFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaticFlag {
    return json as StaticFlag;
}

export function StaticFlagToJSON(value?: StaticFlag | null): any {
    return value as any;
}

export function StaticFlagToJSONTyped(value: any, ignoreDiscriminator: boolean): StaticFlag {
    return value as StaticFlag;
}

